<template>
  <div class="product-detail-coin-exchange-bar"
       @click="handleClickPrimary"
  >
    <div class="product-detail-coin-exchange-bar-item">
      {{ primaryJoin.hint }}
    </div>
  </div>
</template>

<script>

  export default {
    name: 'ProductDetailBottomCoinExchangeBar',
    props: {
      buttons: {
        type: Array,
        required: true,
      },
    },
    computed: {
      primaryJoin() {
        const button = this.buttons.find((item, index) => index === 0);
        button.type = 'primary';
        return button;
      },
    },
    methods: {
      handleClickPrimary() {
        const { targetId, targetType, hint } = this.primaryJoin;
        this.$emit('click-primary', {
          targetId,
          targetType,
          hint,
          page: this.routeName,
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-coin-exchange-bar {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &-item {
      width: 690px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fed100;
      border-radius: 50px;
    }
  }
</style>
